module.exports = __webpack_public_path__ + "static/media/bs.544e1faf.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bs.svg
// module id = 2053
// module chunks = 0